module.exports = __webpack_public_path__ + "img/search-bar-opacity.dff9c01d.svg";